import { LogoProps } from './Logo.types'
import React, { ForwardedRef, forwardRef } from 'react'

const Logo = ({ width = 216, height = 28, ...props }: LogoProps, ref: ForwardedRef<HTMLImageElement>) => {
    const basePath = process.env.NEXT_PUBLIC_BASE_PATH || ''

    return (
        <img {...props} width={width} height={height} ref={ref} src={`${basePath}/new-logo.png`} alt='RE/MAX Delux' />
    )
}

export default forwardRef(Logo)
